import template from './holding-home.html';

const HoldingHomeComponent = {
    bindings: {},
    template,
};

export default HoldingHomeComponent;



// WEBPACK FOOTER //
// ./app/components/home/holding-home/holding-home-component.js